import { render, staticRenderFns } from "./DettaglioFatturazione.vue?vue&type=template&id=a5e5cfd6"
import script from "./DettaglioFatturazione.vue?vue&type=script&lang=js"
export * from "./DettaglioFatturazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports